import actions from '@/core/store/documentos/editor-texto/actions'

export default {
	actions,
}
